import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TopbarCmsData, TopbarCmsRegistro } from '../interfaces/topbar-cms.interface';
import { SingleResponse } from '../interfaces/responses.interface';
import { environment } from 'src/environments/environment';

/**
 * Servicio para consultar y actualizar la configuración del topbar.
 *
 * Propósito: centralizar la comunicación HTTP del CMS de barra superior.
 */
@Injectable({
  providedIn: 'root'
})
export class TopbarService {
  // #region servicios y variables
  private http = inject(HttpClient);
  readonly API_URL = environment.API_URL;
  // #endregion servicios y variables

  /**
   * Obtiene la configuración del topbar desde backend.
   *
   * Flujo: consulta el registro global del módulo topbar.
   *
   * @returns Respuesta con registro tipado del topbar.
   */
  get(): Observable<SingleResponse<TopbarCmsRegistro>> {
    return this.http.get<SingleResponse<TopbarCmsRegistro>>(`${this.API_URL}/topbar/view/1`);
  }

  /**
   * Actualiza la configuración del topbar en backend.
   *
   * Flujo: envía la estructura completa de configuración dentro de `data`.
   *
   * @param data Configuración tipada del topbar.
   * @returns Respuesta con el registro actualizado.
   */
  update(data: TopbarCmsData): Observable<SingleResponse<TopbarCmsRegistro>> {
    return this.http.put<SingleResponse<TopbarCmsRegistro>>(`${this.API_URL}/topbar/update`, {
      data: { id: 1, data }
    });
  }
}
